import { useQuery } from "@tanstack/react-query";
import { WiMuleSQL } from "../../../services/WiMuleSQL";

export const useGetDispatchHistory = (fromDateTime, toDateTime, machine, enabled = true) => {
  // Helper function to ensure the fromDate starts at 00:00:01

const formatFromDate = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0);
  return d.toISOString().split(".")[0];
};

const formatToDate = (date) => {
  const d = new Date(date);
  d.setHours(23, 59, 59);
  return d.toISOString().split(".")[0];
};


  const fetchData = async () => {
  const queryString = `${WiMuleSQL}/api/BWOS/GetIN12DSPHistory?from=${formatFromDate(fromDateTime)}&to=${formatToDate(toDateTime)}&machineId=${machine}`;
    const response = await fetch(queryString, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

   

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`);
    }    
    const json = await response.json();  
    return json.data ?? [];

  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["dispatchHistory", machine, fromDateTime, toDateTime],
    queryFn: fetchData,
    // The query should be enabled only if both fromDateTime and toDateTime are provided
    enabled:enabled && !!fromDateTime && !!toDateTime && !!machine,
    refetchInterval: () =>
      document.visibilityState === "visible" ? 60000 : 600000, // 1 min in focus, 10 min in background
    refetchIntervalInBackground: true, // Ensure background refetching
    refetchOnWindowFocus: true, // Immediate refetch on focus
  });

  return { data, isLoading, isError, error };
};
